import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import logger from 'logger';
import GuestBillingService from 'services/GuestBillingService';
import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import validation from 'pages/User/RegistrationForm/validation.util';
import Button from 'components/Button/Button';
import Input from 'components/Input/Input';
import Modal from 'components/Modal/Modal';
import { RegistrationModalCaller } from 'pages/RegistrationModal/utils';

import styles from './EmailExistsModal.css';


class EmailExistsModal extends PureComponent {
  static propTypes = {
    appActions: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired,
    paymentActions: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
  };

  state = {
    apiError: {
      studioName: null,
      username: null,
    },
    email: {
      isValid: true,
      value: '',
    },
    errorMessageVisible: false,
  };

  closeModal = () => {
    this.props.close(false);
  };

  handleUpdateField = (field, value) => {
    const { state } = this;
    const property = {};

    property[field] = Object.assign({}, state[field], { value });

    this.setState(property);
    validation[field]({ ...property[field], value: property[field].value.trim() }, this.setFieldValue);
  };

  setFieldValue = (field, isValid, errorMessage, currentState, apiCall) => {
    const property = {};
    const translatedErrorMessage = translate(errorMessage);

    if (!apiCall || this.state[field].value.trim() === currentState.value.trim()) {
      property[field] = Object.assign({}, currentState, {
        isValid,
        errorMessage: translatedErrorMessage,
      });

      this.setState(property);
    }
  };

  onClickSubmit = () => {
    const { paymentActions: { toggleUpsellModal } } = this.props;
    GuestBillingService.changeEmail(this.state.email.value)
      .then((res) => {
        if (res.data === 'SUCCESS') {
          const showUpgradeToRegular = true;
          this.props.userActions.getUserState(showUpgradeToRegular, toggleUpsellModal);
          this.closeModal();
        }
      })
      .catch((err) => logger.error(err));
  };

  onClickOpenLoginModal = () => {
    const { appActions, close } = this.props;
    close(false);

    const handleOpenRegistrationModal = () => {
      appActions.setShowRegistrationModal(true, RegistrationModalCaller.EMAIL_EXISTS_MODAL);
    };

    const modalKey = ModalService.MODAL_KEYS.LOGIN_MODAL_V2;
    const modalProps = { handleOpenRegistrationModal };

    ModalService.showModal(modalKey, modalProps);
  };

  onChangeEmailInput = (event) => {
    const { value } = event.target;
    this.handleUpdateField('email', value);
  };

  render() {
    const { email } = this.state;

    return (
      <Modal close={this.closeModal} show={true}>
        <div className={styles.alertDanger}>{translate('profile.profile.oops.email.already.in.use')}</div>
        <p className={styles.spacing}>{translate('profile.profile.use.different.email.to.receive.tokens')}</p>
        <p className={styles.spacing}>
          <Input
            errorText={email.errorMessage}
            inputMargin="0"
            label={translate('homepage.v2.studio.enter.an.email.address')}
            name="Email"
            type="email"
            valid={email.isValid}
            value={email.value}
            onChange={this.onChangeEmailInput}
          />
        </p>
        <Button
          colour="orange"
          disabled={!email.isValid}
          label={translate('profile.profile.update.now')}
          onClick={this.onClickSubmit}
        />
        <div className={styles.delimiter}>
          <span className={styles.openLoginModal} onClick={this.onClickOpenLoginModal}>
            {translate('gold.gold.Already.have.account')}{' '}
            <span className={styles.signUpHere}>{translate('gold.gold.sign.here')}</span>
          </span>
        </div>
      </Modal>
    );
  }
}

export default EmailExistsModal;
